import { render, staticRenderFns } from "./newspaper-details.vue?vue&type=template&id=904a6930"
import script from "./newspaper-details.vue?vue&type=script&lang=js"
export * from "./newspaper-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports